<template>
  <div class="page">
    <navigation
      class="header"
      :theme="{
        background: '#fff',
      }"
      :showBack="false"
    >账号注销
    </navigation>
    <div class="content">
      <div class="separator"></div>
      <signout-result-status :result="result"/>
      <signout-result-actions :result="result"/>
      <call-service-button
        class="call"
        @onCall="serviceDialogVisible=true"
      />
      <div class="call-tips">需要帮助，请联系客服</div>
    </div>
    <service-jw v-model="serviceDialogVisible"></service-jw>
  </div>
</template>

<script>
import signoutResultStatus from '@/view/mine/signout/components/signout-result-status'
import signoutResultActions from '@/view/mine/signout/components/signout-result-actions'
import callServiceButton from '@/components/service-button'

export default {
  name: 'auth-result',
  components: {
    signoutResultStatus,
    signoutResultActions,
    callServiceButton,
    serviceJw: () => import('@/components/service-jw')
  },
  async created () {
    if (this.signedOut && this.signedOut === 'Y') {
      this.$bus.$emit('ready')
    } else {
      this.$router.replace({
        path: '/mine/signout/reason'
      })
    }
  },
  data () {
    return {
      serviceDialogVisible: false,
      signedOut: this.$route.query.signedOut,
      result: {
        code: 'SUCCESS',
        status: 'SUCCESS',
        title: '注销成功',
        desc: '您的账户已注销，您本次登录即将失效'
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  width: 750px;
  height: 100%;
  background: #fff;
  .content {
    .separator {
      width: 100%;
      height: 20px;
      background: #fafafa;
    }
  }
  .call {
    position: absolute;
    bottom: 193px;
    left: 275px;
  }
  .call-tips {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 33px;
    position: absolute;
    bottom: 140px;
    left: 255px;
  }
}
</style>